import register from 'ShopUiBundle/modules/app/registry';
import './sticky-buybox.scss';

// tslint:disable-next-line
register('sticky-buybox', () => import(/* webpackMode: "lazy" */'./sticky-buybox'));
